export default __webpack_public_path__ + "734c4ab2f3b9e762198c3b75ca256427.png";